import { render } from "./DeviceAccessibilitySection.vue?vue&type=template&id=29838443&scoped=true"
import script from "./DeviceAccessibilitySection.vue?vue&type=script&lang=js"
export * from "./DeviceAccessibilitySection.vue?vue&type=script&lang=js"

import "./DeviceAccessibilitySection.vue?vue&type=style&index=0&id=29838443&lang=postcss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29838443"]])

export default __exports__